import type { FC } from "react";
import { Banner, BannerType } from "@stubhub/broadway-web";
import { TicketsFillIcon } from "@stubhub/broadway-web/icons/functional";
import { FormatContent } from "src/shared/components/content";
import { numTicketsPurchasedContainer } from "src/website-apps/responsive/stubhub-performer/components/info-banners/styles";

interface TicketsPurchasedBannerProps {
  count: number;
}

/**
 * Social proof banner showing number of tickets purchased in the last day for a given performer
 * AB 101203
 */
export const TicketsPurchasedBanner: FC<TicketsPurchasedBannerProps> = ({ count }) => {
  return (
    <Banner classes={{ wrapper: numTicketsPurchasedContainer }} type={BannerType.Info} icon={TicketsFillIcon}>
      <FormatContent id="cid$#4040063#" params={[count]} />
    </Banner>
  );
};
